import { render } from "./iconInstagram.vue?vue&type=template&id=1872f39b&scoped=true"
import script from "./iconInstagram.vue?vue&type=script&lang=js"
export * from "./iconInstagram.vue?vue&type=script&lang=js"

import "./iconInstagram.vue?vue&type=style&index=0&id=1872f39b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1872f39b"

export default script